var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-0.45 -0.45 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.22 3.373c3.657 2.612 6.037 6.884 6.037 11.72 0 7.941-6.432 14.379-14.367 14.396C6.966 29.507.476 23.046.464 15.116.46 10.281 2.84 5.996 6.49 3.38a1.397 1.397 0 0 1 2.032.446l.917 1.632c.342.61.18 1.381-.383 1.8-2.41 1.787-3.948 4.62-3.948 7.83-.005 5.358 4.325 9.758 9.753 9.758 5.317 0 9.787-4.307 9.752-9.816A9.756 9.756 0 0 0 20.66 7.25a1.385 1.385 0 0 1-.377-1.793l.917-1.632a1.391 1.391 0 0 1 2.02-.452zm-6.037 12.184V1.625A1.39 1.39 0 0 0 15.79.232h-1.858a1.39 1.39 0 0 0-1.393 1.393v13.932a1.39 1.39 0 0 0 1.393 1.394h1.858a1.39 1.39 0 0 0 1.393-1.394z",
    id: "0126677b-44d9-45de-bcf2-3a08119ec23d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.f6b2a0f47cd75c7782c74001f0a904d9.svg";
export { ForwardRef as ReactComponent };